import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isNil } from 'lodash';
import { Chip, Grid } from '@material-ui/core';
import moment from 'moment-timezone';
import SelectElement from 'containers/CourtManagerAssignedExpertise/SelectElement';
import TextElement from 'containers/CourtManagerAssignedExpertise/TextElement';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import victimIcon from 'images/victim-icon.svg';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { COLORS } from 'constants/design';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { translate } from 'containers/services/translate';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import messages from 'containers/TransactionManagerTimeLine/ContactVictim/messages';

export interface MissionRecapProps {
  intl: IntlShape;
  missions: any;
  listings: any;
}

const StyledGrid = {
  color: COLORS.TEXT_BLACK,
  fontWeight: 500,
  fontSize: '15px',
};
const StyledTitle = {
  padding: '12px 24px',
  color: COLORS.TEXT_BLACK,
  fontWeight: 400,
  fontSize: '1rem',
};
export const StyledSubTitle = {
  color: COLORS.LIGHT_GREY_TEXT,
  fontWeight: 400,
  fontSize: '15px',
  marginLeft: '25px',
};
const MissionRecap: FC<MissionRecapProps> = props => {
  return (
    <>
      {props.missions?.map((mission: any) => (
        <CustomAccordion
          title={translate({ ...messages.missionAccordionTitle }, props, {
            reference: mission.reference,
          })}
          textColor={COLORS.ACCORDION_TEXT_BLUE}
          bgColor={COLORS.ACCORDION_BG_BLUE}
          image={victimIcon}
        >
          <Grid container direction="row">
            <Grid item xs={12}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={4}>
                  <TextElement
                    label={translate(messages.expertiseNature, props)}
                    //@ts-ignore
                    value={getValueByCode(
                      mission?.type,
                      get(props.listings, 'expertise'),
                    )}
                    withoutPadding={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <SelectElement
                    label={translate(messages.expert, props)}
                    value={mission.assignedExperts.map((element: any) => ({
                      value: element.expertCode,
                      title: getValueByCodeSagis(
                        element.expertCode,
                        get(props.listings, 'intervenants'),
                      ),
                    }))}
                    multiple={true}
                    withoutPadding={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextElement
                    label={translate(messages.missionDate, props)}
                    value={moment(mission.missionDate).format('YYYY-MM-DD')}
                    withoutPadding={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            {mission.assignedExperts && (
              <Grid item xs={12}>
                {mission.assignedExperts.map(
                  (el: { expertCode: string; reason: string }, i: number) => (
                    <>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ padding: '15px 0px' }}
                        key={i}
                      >
                        <Grid item style={StyledGrid}>
                          {getValueByCodeSagis(
                            get(el, 'expertCode') as string,
                            get(props.listings, 'intervenants'),
                          ) + ' : '}
                        </Grid>
                        <Grid item xs={11}>
                          <Chip
                            style={{
                              backgroundColor: renderColor(
                                getValueByCode(
                                  get(el, 'status') as any,
                                  get(props.listings, 'missionStatus'),
                                ) as any,
                              ),
                              color: COLORS.WHITE,
                              fontWeight: 700,
                            }}
                            label={renderChipLabel(
                              getValueByCode(
                                get(el, 'status') as any,
                                get(props.listings, 'missionStatus'),
                              ) as any,
                            )}
                          />
                        </Grid>
                      </Grid>
                      {!isNil(get(el, 'reason', null)) && (
                        <>
                          <Grid style={StyledTitle}>
                            {translate(messages.rejectionReason, props)}
                          </Grid>
                          <Grid item style={StyledSubTitle}>
                            {get(el, 'reason', null)}
                          </Grid>
                        </>
                      )}
                    </>
                  ),
                )}
              </Grid>
            )}
          </Grid>
        </CustomAccordion>
      ))}
    </>
  );
};

export default injectIntl(MissionRecap);
